<template>
  <div class='the-gallery'>
     <gallery :images="fullSizeImages" :index="index" @close="index = null"></gallery>
     <div
       class="image cursor-pointer"
       v-for="(image, imageIndex) in images"
       :class="['img-'+imageIndex]"
       :key="imageIndex"
       @click="index = imageIndex"
       :style="{ backgroundImage: 'url(' + image.thumbnail + ')'}"
     ></div>
   </div>
</template>

<script>
import VueGallery from 'vue-gallery';

export default{
  components: {
    'gallery': VueGallery
  },


  props : {
    galleryImages : {
      type : Array,
      required : false,
      default : () => []
    }
  },


  data(){
      return {
        images: [
          // 'https://dummyimage.com/800/ffffff/000000',
          // 'https://dummyimage.com/1600/ffffff/000000',
          // 'https://dummyimage.com/1280/000000/ffffff',
          // 'https://dummyimage.com/400/000000/ffffff',
        ],

        index: null
      };
    },

    computed : {
      fullSizeImages(){
        return this.images.map(img=>img.fullSize)
      }
    },


    mounted(){
      this.images = this.galleryImages
    }

  }
</script>



// WEBPACK FOOTER //
// src/homepage/Gallery.vue